import React from 'react';
import './Pricing.css';
import { ArrowRight, Check, Info, AlertTriangle, MessageSquare } from "lucide-react";

export default function Pricing() {
  const serviceCategories = [
    {
      id: "cover-art",
      title: "COVER ART",
      icon: "💿",
      services: [
        {
          name: "Single Cover (desde fotografía)",
          price: "$100 USD",
          description: "Edición y composición sobre imagen existente"
        },
        {
          name: "Single Cover (conceptual desde cero)",
          price: "$150 USD",
          description: "Dirección creativa + construcción visual completa"
        },
        {
          name: "Single Cover + Motion",
          price: "$200 USD",
          description: "Cover + animación tipo loop (ideal para redes / Spotify Canvas)"
        }
      ]
    },
    {
      id: "album-design",
      title: "DISEÑO DE ÁLBUM (PACK COMPLETO)",
      icon: "📀",
      highlighted: true,
      services: [
        {
          name: "Pack Completo",
          price: "Desde $350 USD",
          features: [
            "Portada principal",
            "Tracklist",
            "Motion (loop animado)",
            "Diseños para redes sociales"
          ]
        }
      ]
    },
    {
      id: "logos",
      title: "LOGOS",
      icon: "🧠",
      services: [
        {
          name: "Identidad Visual",
          price: "$150 USD – $300 USD",
          description: "Diseño de identidad visual + versiones adaptadas (según alcance)"
        }
      ]
    },
    {
      id: "flyers",
      title: "FLYERS",
      icon: "📢",
      services: [
        {
          name: "Flyer Simple",
          price: "$100 USD",
          description: "Diseño limpio y directo para promoción"
        },
        {
          name: "Flyer Premium",
          price: "Desde $150 USD",
          description: "Concepto creativo + mayor nivel de detalle visual"
        }
      ]
    },
    {
      id: "lettering",
      title: "LETTERING",
      icon: "🔠",
      services: [
        {
          name: "Lettering 2D",
          price: "Desde $100 USD",
          description: "Diseño tipográfico plano"
        },
        {
          name: "Lettering 3D",
          price: "$200 USD",
          description: "Renderizado en Blender / Cinema 4D"
        }
      ]
    }
  ];

  return (
    <section id="servicios" className="pricing-section">
      <div className="pricing-container">
        {/* Header */}
        <div className="pricing-header">
          <h2 className="aurora-main-title pricing-title">
            SERVICIOS & <span className="text-blue">PRECIOS</span>
          </h2>
          <p className="pricing-subtitle">
            Soluciones de diseño de alto nivel adaptadas a la industria musical. 
            Identidades visuales y portadas personalizadas que destacan entre el ruido.
          </p>
        </div>

        {/* Categories Grid/List */}
        <div className="pricing-categories">
          {serviceCategories.map((category) => (
            <div key={category.id} className={`category-card ${category.highlighted ? 'card-highlight' : ''}`}>
              <div className="category-header">
                <span className="category-icon">{category.icon}</span>
                <h3 className="category-title">{category.title}</h3>
              </div>
              
              <div className="services-list">
                {category.services.map((service, idx) => (
                  <div key={idx} className="service-item">
                    <div className="service-info">
                      <h4 className="service-name">{service.name}</h4>
                      {service.description && <p className="service-desc">{service.description}</p>}
                      {service.features && (
                        <ul className="service-features">
                          {service.features.map((feat, fidx) => (
                            <li key={fidx}><Check size={12} /> {feat}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                    <div className="service-price-box">
                      <span className="service-price">{service.price}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="category-footer">
                <a 
                  href={`https://wa.me/584242603751?text=Hola%20quiero%20información%20sobre%20${encodeURIComponent(category.title)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="category-btn"
                >
                  SOLICITAR <ArrowRight size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Global Policies & Notes */}
        <div className="pricing-footer-info">
          <div className="info-block policy-block">
            <div className="block-header">
              <AlertTriangle size={20} className="icon-warning" />
              <h3>POLÍTICA DE CAMBIOS</h3>
            </div>
            <ul>
              <li>✔ Todos los servicios incluyen hasta <strong>3 revisiones</strong></li>
              <li>➕ A partir del 4to cambio: <strong>$15 USD</strong> por ajuste adicional</li>
            </ul>
          </div>

          <div className="info-block notes-block">
            <div className="block-header">
              <Info size={20} className="icon-info" />
              <h3>NOTAS IMPORTANTES</h3>
            </div>
            <ul>
              <li>→ Precios pueden variar según complejidad del proyecto</li>
              <li>→ Entregas en alta calidad (4K / formatos profesionales)</li>
              <li>→ Se recomienda briefing claro para mejores resultados</li>
            </ul>
          </div>
        </div>

        {/* Custom Package CTA */}
        <div className="custom-package-cta">
          <h2 className="cta-title">¿NECESITAS UN PACK PERSONALIZADO?</h2>
          <p className="cta-subtitle">
            Creamos soluciones a medida para proyectos complejos. Hablemos de tu visión y tracemos una ruta personalizada.
          </p>
          <a
            href="https://wa.me/584242603751?text=Hola%20quiero%20información%20sobre%20tus%20servicios%20personalizados"
            target="_blank"
            rel="noopener noreferrer"
            className="pricing-btn btn-premium cta-btn"
          >
            CONTACTAR ESTUDIO <MessageSquare size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
